import { getAuth } from "firebase/auth";

export default function getAuthenticatedUser() {
  const auth = getAuth();

  return auth?.currentUser;
}
